<template>
  <div class="box5">
    <img src="../../../assets/coursePage/media/box5/img.png" alt="" />
    <p>
      “东方甄选”直播间，
      <span>618累计销售额破3亿；</span>
    </p>
    <p>某知名主播一场直播带货销售额几千万；</p>
    <p>“口红哥” <span>月盈利可达10位数...</span></p>
    <p>短视频、直播的带货变现能力让人大开眼界！</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box5 {
  position: relative;
  width: 100%;

  background: url("../../../assets/coursePage/media/box4/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0px 8px 24px 0px rgba(136, 97, 255, 0.12);
  border-radius: 20px;
  img {
    width: 628px;
    height: 332px;

    overflow: hidden;
    margin: 14px auto 32px;
    display: block;
  }
  p {
    text-align: justify;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #555266;
    line-height: 40px;
    padding: 0 32px;
    box-sizing: border-box;
    margin-bottom: 16px;
    span {
      color: rgba(255, 0, 0, 1);
      font-family: PingFangSC-Medium;
      font-size: 24px;
    }
  }
}
</style>
